import Button from 'components/Form/Button';
import Breadcrumb from 'components/Navigation/Breadcrumb';
import React, { useMemo } from 'react';
import BankAssets from './AssetsTypes/Bank/BankAssets';
import BondAssets from './AssetsTypes/Bond/BondAssets';
import PensionAssets from './AssetsTypes/Pension/PensionAssets';
import StockAssets from './AssetsTypes/Stock/StockAssets';
import BenefitAssets from './AssetsTypes/Benefit/BenefitAssets';
import PhysicalAssets from './AssetsTypes/Physical/PhysicalAssets';
import { Link } from 'react-router-dom';
import { AllAsset } from 'constants/dashboard-stats';
import { useAppSelector } from 'store/hooks';
import { selectAccountDetails } from 'selectors/account-selector';
import { STEPS } from 'constants/steps';

export default function Assets() {
  const { user } = useAppSelector(selectAccountDetails);

  const allowPage = useMemo(() => {
    if (user) {
      return JSON.parse(user.planAllowPage);
    }
  }, [user]);

  return (
    <div>
      <div className="flex items-center justify-between">
        <Breadcrumb title="Assets" />
        {allowPage.includes(STEPS.TRUSTEE_INFORMATION) && (
          <Link to="trustee/manage-trustee">
            <Button
              variant="primary"
              size="md"
              className={`mt-1 w-[12rem] rounded border border-[#FF6600] bg-[#FF66001A] font-semibold text-[#FF6600]`}
              label="Trustee Management"
            ></Button>
          </Link>
        )}
      </div>

      <div className="mt-2 h-[850px] overflow-auto pb-10 scrollbar-hide">
        {AllAsset.filter(stat => allowPage.includes(stat.pageId)).map(asset => {
          if (asset.key === 'Bank') {
            return <BankAssets key={asset.pageId} />;
          }
          if (asset.key === 'Bond') {
            return <BondAssets key={asset.pageId} />;
          }
          if (asset.key === 'Pension') {
            return <PensionAssets key={asset.pageId} />;
          }
          if (asset.key === 'Stock') {
            return <StockAssets key={asset.pageId} />;
          }
          if (asset.key === 'Benefit') {
            return <BenefitAssets key={asset.pageId} />;
          }
          if (asset.key === 'Physical') {
            return <PhysicalAssets key={asset.pageId} />;
          }
        })}
      </div>
    </div>
  );
}
